import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";
import {
  FaHotel,
  FaPlane,
  FaCar,
  FaMapMarkedAlt,
  FaHeadset,
  FaShieldAlt,
  FaUtensils,
  FaPassport // ✅ ADD THIS
} from "react-icons/fa";
import CTASection from "../components/CTASection";
import { UsersIcon, GlobeAltIcon, HeartIcon, ShieldCheckIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { Helmet } from "react-helmet-async";

export default function Services() {
  const services = [
    {
      icon: <FaHotel />,
      title: "Hotel Booking",
      desc: "Book top-rated hotels at the best prices with instant confirmation.",
      link: "https://beachhotelsdubai.com/",
    },
    {
      icon: <FaPlane />,
      title: "Flight Booking",
      desc: "Get affordable flights worldwide with flexible options.",
      link: "https://southtravels.com/flights",
      popular: true
    },
    {
      icon: <FaPassport />,
      title: "Visa Services",
      desc: "Get hassle-free visa assistance with fast processing and expert guidance.",
      link: "https://southtravels.com/",
      popular: true // ✅ MOVE IT HERE
    },
    {
      icon: <FaMapMarkedAlt />,
      title: "Tour Packages",
      desc: "Explore curated travel packages to top destinations.",
      link: "https://tourismindubai.com/",
    },
    {
      icon: <FaUtensils />,
      title: "Food & Dining",
      desc: "Enjoy curated dining experiences and exclusive restaurant deals.",
      link: "https://dubaicitytour.com/",
    },
    {
      icon: <FaCar />,
      title: "Car Rentals",
      desc: "Rent luxury and budget cars for your travel convenience.",
      link: "https://southtravels.com/car-rental-from-dubai",
    },
  ];

  const features = [
    {
      icon: <FaShieldAlt />,
      title: "Secure Booking",
      desc: "Your data is protected with advanced security systems.",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      desc: "Our team is available anytime to assist you.",
    },
    {
      icon: <FaHotel />,
      title: "Best Hotels",
      desc: "We partner with top-rated hotels worldwide.",
    },
    {
      icon: <FaPassport />,
      link: "https://southtravels.com/",
      popular: true // ✅ MUST be here
    },
    {
      icon: <FaPlane />,
      link: "https://southtravels.com/flights",
      popular: true // ✅ MUST be here
    }
  ];

  return (

    <>
      <Helmet>
        <title>
          Travel & Hotel Services | Beach Hotels Dubai
        </title>

        <meta
          name="description"
          content="Explore affordable hotel booking, budget travel planning, cheap holiday packages, airport transfers, and travel services with Beach Hotels Dubai."
        />

        <link
          rel="canonical"
          href="https://beachhotelsdubai.com/services"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Travel & Hotel Services | Beach Hotels Dubai"
        />

        <meta
          property="og:description"
          content="Explore affordable hotel booking, budget travel planning, cheap holiday packages, airport transfers, and travel services with Beach Hotels Dubai."
        />

        <meta
          property="og:url"
          content="https://beachhotelsdubai.com/services"
        />

        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Travel & Hotel Services | Beach Hotels Dubai"
        />

        <meta
          name="twitter:description"
          content="Explore affordable hotel booking, budget travel planning, cheap holiday packages, airport transfers, and travel services with Beach Hotels Dubai."
        />

        <meta
          name="robots"
          content="index, follow"
        />
      </Helmet>


      <div className="w-full">

        {/* 🔥 HERO SECTION */}
        <Hero
          variant="inner"
          title="Our Services"
          subtitle="Explore everything we offer to make your stay perfect"
          backgroundImage={hotelImg}
        />

        {/* 💼 SERVICES GRID */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12 text-gray-800">
            What We Offer
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {services.map((service, index) => (
              <a
                href={service.link}
                target="_blank"
                rel="noopener noreferrer"
                key={index}
                className="group relative overflow-hidden bg-white p-6 sm:p-8 rounded-3xl shadow hover:shadow-2xl hover:-translate-y-1 sm:hover:-translate-y-2 transition duration-300 border block"
              >
                {service.popular && (
                  <span className="absolute top-3 right-[-45px] rotate-45 bg-gradient-to-r from-[#0F172A] to-[#FF8C42] text-white text-[10px] px-12 py-1 shadow-md font-semibold tracking-wider">
                    POPULAR
                  </span>
                )}

                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-orange-100 text-[#0F172A] rounded-xl mb-4 group-hover:scale-110 transition">
                  {service.icon}
                </div>

                <h3 className="text-xl font-semibold mb-2 text-gray-800">
                  {service.title}
                </h3>

                <p className="text-gray-600 text-sm">{service.desc}</p>

                <div className="mt-4 text-[#0F172A] font-semibold text-sm group-hover:underline">
                  Explore Service →
                </div>
              </a>
            ))}
          </div>
        </div>



        {/* Why Choose Us - Modern Cards */}
        <section className="bg-gray-100 py-20 px-6">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-12">
              Why Choose Us
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
              {[
                {
                  icon: UsersIcon,
                  title: "Trusted by Users",
                  desc: "Thousands of happy customers worldwide",
                },
                {
                  icon: GlobeAltIcon,
                  title: "Global Destinations",
                  desc: "Explore hotels across top locations",
                },
                {
                  icon: HeartIcon,
                  title: "Best Experience",
                  desc: "We focus on comfort and satisfaction",
                },
                {
                  icon: ShieldCheckIcon,
                  title: "Secure Booking",
                  desc: "Safe and reliable transactions",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="group bg-white p-8 rounded-3xl shadow-md hover:shadow-[0_20px_40px_rgba(255,107,53,0.15)] transition relative overflow-hidden"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A] to-[#FF8C42] opacity-0 group-hover:opacity-10 transition"></div>

                  <item.icon className="w-12 h-12 mx-auto text-[#0F172A] mb-4 group-hover:scale-110 transition" />

                  <h4 className="font-semibold mb-2 text-lg text-gray-800">
                    {item.title}
                  </h4>

                  <p className="text-sm text-gray-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA - Enhanced */}
        <CTASection />

      </div>
    </>
  );
}